import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKBadge from "components/MKBadge";
import MKTypography from "components/MKTypography";

// Material Kit 2 PRO React components
import SimpleBlogCard from "examples/Cards/BlogCards/SimpleBlogCard";

function Requirements() {
    <MKBox component="section" py={{ xs: 6, md: 12 }}>
        <MKTypography variant="h2" mb={1}>Requisitos</MKTypography>
    </MKBox>
};

export default Requirements;